export default __webpack_public_path__ + "static/media/dk3.947a5b92.jpg";